<template>
  <ul class="bpl__tabs" v-if="hasArchives">
    <li class="bpl__tabs__item" :class="{'bpl__tabs__item--active': !isArchive}" @click="changeArchiveMode(false)">Index</li>
    <li class="bpl__tabs__item" :class="{'bpl__tabs__item--active': isArchive}" @click="changeArchiveMode(true)">Archive</li>
  </ul>
</template>

<script>
import { changeArchiveMode } from "./BluePrintingLevelActions";

export default {
  vuex: {
    getters: {
      hasArchives: state => state.hasArchives,
      isArchive: state => state.isArchive
    },
    actions: { changeArchiveMode }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';
  @import '../../assets/scss/elements/button.scss';

  .bpl__tabs{
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 20px 0 0;
    float: right;

    &__item{
      @extend .simple-button;
      margin: 0 0px 0px 5px;

      &--active{
        color: $green;
        cursor: default;

        &:hover{
          background: $green_dark;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// BluePrintingLevelTabs.vue?cc9a70f8